import React from "react";
import logo from "../../assets/image/svg/Logo.svg";
import { Link } from "react-router-dom";

export default function Header() {
  return (
    <div className="background mt-3">
      <div className="container">
        <div className="row">
          <nav className="navbar navbar-expand-lg">
            <div className="container-fluid">
               
<Link to="/">
<img className="Logo" src={logo} alt="logo" /></Link>

              {/* Button for offcanvas on mobile */}
              <button
  className="d-lg-none bgT d-flex border-0 zIndex"
  type="button"
  data-bs-toggle="offcanvas"
  data-bs-target="#offcanvasRight"
  aria-controls="offcanvasRight"
>

                <div className="navmemu">
                  <div className="navdot"></div>
                  <div className="navdot my"></div>
                  <div className="navdot"></div>
                </div>
              </button>

              {/* Normal navbar for desktop */}
              <div className="collapse navbar-collapse d-none d-lg-block">
                <ul className="navbar-nav ms-auto gap-lg-5 gap-3">
                    
                      <li className="nav-item mt-2">
                    <a className="NAV-LINK fw-medium" href="#howitwork">
                      How It Works
                    </a>
                  </li>
                   <li className="nav-item mt-2">
                    <a className="NAV-LINK fw-medium" href="#about">
                      About Us
                    </a>
                  </li>
                   <li className="nav-item mt-2">
                    <a className="NAV-LINK fw-medium" href="#service">
                      Services
                    </a>
                  </li>
                 
                 
                
                  <li className="nav-item ">
                    <a href="#downloadLink">
                      <button className="text-white px-4 fw-medium rounded-2 py-2 border-0 bg640D5F">
                        Download App
                      </button>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>

      <div className="border_bottom mt-3"></div>

      <div
  className="offcanvas offcanvas-end"
  tabIndex="-1"
  id="offcanvasRight"
  aria-labelledby="offcanvasRightLabel"
>
        <div className="offcanvas-header itesm-center d-flex  mt-2">
           <img className="Logo" src={logo} alt="logo" />
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <ul className="navbar-nav gap-3">
             <li className="nav-item mt-3">
              <a className="NAV-LINK fw-medium" href="#howitwork">
                How It Works
              </a>
            </li>
             <li className="nav-item mt-3">
              <a className="NAV-LINK fw-medium" href="#about">
                About Us
              </a>
            </li>
            <li className="nav-item mt-3">
              <a className="NAV-LINK fw-medium" href="#service">
                Services
              </a>
            </li>
           
           
            <li className="nav-item mt-5">
              <a href="#downloadLink">
                <button className="text-white px-4 fw-medium rounded-2 py-2 border-0 bg640D5F">
                  Download App
                </button>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
